/* DON'T EDIT THIS FILE: edit original and run build again */ export type Empty = Record<string, never>;
export const frozenEmptyObject: Empty = {};
Object.freeze(frozenEmptyObject);
